<div id="all-content" fxLayoutAlign="start center" fxLayout="column" *ngIf="haveData">
  <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()">
    <div>
      <h1 class="heading">Join {{ accountName }}'s Lineup account.</h1>
      <br />
      <dl>
        <dt>Your Account URL</dt>
        <dd>{{ accountUrl }}</dd>
        <dt>Your Login Email</dt>
        <dd>{{ userEmail }}</dd>
      </dl>
      <br />
      <div class="instruction">Please set the password for your account.</div>
      <div class="field" fxLayout="column">
        <div class="form-label">Password<span class="required">*</span></div>
        <mat-form-field appearance="outline" floatLabel="always">
          <input matInput type="password" formControlName="password" />
          <mat-error id="password-strength-err" *ngIf="passwordForm.get('password').hasError('passwordStrengthError')">
            {{ passwordStrengthError }}
          </mat-error>
          <mat-error id="password-mismatch-err" *ngIf="passwordForm.get('password').hasError('passwordMismatchError')">
            {{ passwordMismatchError }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="field" fxLayout="column">
        <div class="form-label">Confirm Password<span class="required">*</span></div>
        <mat-form-field appearance="outline" floatLabel="always">
          <input matInput type="password" formControlName="confirmPassword" />
          <mat-error
            id="confirm-password-strength-err"
            *ngIf="passwordForm.get('confirmPassword').hasError('passwordStrengthError')"
          >
            {{ passwordStrengthError }}
          </mat-error>
          <mat-error
            id="confirm-password-mismatch-err"
            *ngIf="passwordForm.get('confirmPassword').hasError('passwordMismatchError')"
          >
            {{ passwordMismatchError }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <re-captcha formControlName="recaptcha" [siteKey]="recaptchaSiteKey" *ngIf="recaptchaSiteKey"></re-captcha>
    <button
      class="mat-raised-button submit-button"
      mat-button
      color="primary"
      type="submit"
      [disabled]="!isSubmitEnabled()"
    >
      Set Password
    </button>
  </form>
</div>
